
import { biLoggerFactory } from 'wix-private';
const biLogger = biLoggerFactory('xdc', 110, { msid: '2467fcd2-6eff-4b37-b860-1dc33aa86e0d' });
/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 
 */
function fireEvent(buttonName){
      const biEventObject = {
        evid: 2001,
        ctaLocation:$w('#page1').title,
        ctaName: 'Start Designing',
        topic: 'Design Classes',
        brand_name: 'editor x'
    };
     biLogger.log(biEventObject); 
 }
export function BIboxTryOnEditorX_click(event) {
	 fireEvent('Design Classes')
}

export function box57_click(event) {
    fireEvent('Gets skilled up') 
}

export function box58_click(event) {
	fireEvent('Read articles')
}


export function box59_click(event) {
	fireEvent('Join the discussion')
}